import {ServicePerformanceComponent} from "./service-performance.component";

export default ServicePerformanceComponent
